<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible.sync="visible"
      direction="rtl"
      :size="915"
      show-close
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :amzFirstDemandDetailCode="amzFirstDemandDetailCode"
          :disabled="disabled"
          :planningDisabled="planningDisabled"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.confirm()"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    planningDisabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzFirstDemandDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}
</style>
